import { RedoOutlined, SearchOutlined } from "@ant-design/icons"
import { Button, Card, ConfigProvider, Form, Input, Space } from "antd"
import type React from "react"
import { memo, useEffect } from "react"
import type { IdiomSearchParams } from "@/services/dictionary/idiomApi"

interface IdiomSearchFormProps {
  onSearch: (values: Omit<IdiomSearchParams, "page" | "per_page">) => void
  loading?: boolean
  initialValues?: Omit<IdiomSearchParams, "page" | "per_page">
}

const IdiomSearchForm: React.FC<IdiomSearchFormProps> = memo(({ onSearch, loading = false, initialValues }) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues)
    }
  }, [initialValues, form])

  const handleSearch = () => {
    form.validateFields().then((values) => {
      onSearch(values)
    })
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({
      search: "",
    })
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            itemMarginBottom: 0,
          },
        },
      }}
    >
      <Card>
        <Form
          form={form}
          initialValues={{
            search: "",
          }}
          className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3"
        >
          <Form.Item name="search" label="Thành ngữ" colon={false} className="mb-0">
            <Input allowClear autoComplete="off" placeholder="Tìm kiếm thành ngữ..." onPressEnter={handleSearch} />
          </Form.Item>

          <Form.Item label=" " colon={false} className="mb-0">
            <Space>
              <Button type="default" icon={<RedoOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SearchOutlined />}
                onClick={handleSearch}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </ConfigProvider>
  )
})

IdiomSearchForm.displayName = "IdiomSearchForm"

export default IdiomSearchForm
